import React from 'react';
import { getFunName } from '../helpers';

class StorePicker extends React.Component {

	// constructor() {
	// 	super();
	// 	this.goToStore = this.goToStore.bind( this );
	// }

	goToStore( event ) {
		event.preventDefault();
		// first grab the text from the box
		const storeId = this.storeInput.value;
		// second, we're going to transition from / to /store/:storeId
		this.context.router.transitionTo( `/store/${storeId}` )
	}

	render() {
		return (
			<form action="" className="store-selector" onSubmit={this.goToStore.bind( this )}>
				<h2>Please Enter a Store</h2>
				<input type="text" required placeholder="Store Name" defaultValue={getFunName()} ref={(input) => { this.storeInput = input }} />
				<button type="submit">Visit Store &rarr;</button>
			</form>
		)
	}

}

/**
 * Make the router available to our StorePicker component
 */
StorePicker.contextTypes = {
	router: React.PropTypes.object
}

export default StorePicker;



/** WEBPACK FOOTER **
 ** ./src/components/StorePicker.js
 **/